import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '../../../../_metronic/i18n/Metronici18n'
import { NovidadesListWrapper } from './novidades/NovidadesList'
import { NovidadeDetalhe } from './novidades/NovidadeDetalhe'

/** Histórico de notas de versão para qualquer usuário autenticado: lista e detalhe por id. */
const NovidadesPage = () => {
  const { t } = useT()

  return (
    <>
      <PageTitle description={t('pagina.novidades.descricao')}>{t('menu.novidades')}</PageTitle>
      <Routes>
        <Route path='' element={<NovidadesListWrapper />} />
        <Route path=':id' element={<NovidadeDetalhe />} />
      </Routes>
    </>
  )
}

export default NovidadesPage
